import {
  PAYMENT_ERRORS,
  REPLENISHMENT,
  PRODUCT,
  PRO,
  CART,
  ADDRESS,
  RESTRICTION_ERRORS,
  GIFT_MESSAGE,
} from './Errors';

import {
  ADDRESS_NOTIFICATIONS,
  SHIPPING_NOTIFICATIONS,
  SHIPPING_PAYMENT_NOTIFICATIONS,
  BOPIS_NOTIFICATION,
  CART_NOTIFICATIONS,
  CVS_NOTIFICATIONS,
} from './Notifications';

// Used to map the notifications keys to it's corresponding translations by the NotificationService
export const API_NOTIFICATION_KEY_TRANSLATIONS_MAP = Object.freeze({
  [ADDRESS.INVALID_NAMES]: 'nameInvalid',
  [ADDRESS.INVALID_CITY]: 'cityInvalid',
  [ADDRESS.INVALID_STATE]: 'stateInvalid',
  [ADDRESS.INVALID_ZIP]: 'cityZipInvalid',
  [ADDRESS.INVALID_STATE_ZIP]: 'cityStateZipInvalid',
  [ADDRESS.INVALID_ZIP_FOR_PROVINCE]: 'cityStateZipInvalid',
  [ADDRESS.INVALID_ADDRESS]: 'addressInvalid',
  [ADDRESS.INVALID_AUPOST_QAS_ADDRESS]: 'addressInvalid',
  [ADDRESS.INVALID_BILLING_ADDRESS_SELECTED]: 'invalidBillingAddressSelected',
  [ADDRESS.INVALID_DELIVERY_INSTRUCTIONS]: 'deliveryInstructionsInvalid',
  [ADDRESS.SHIPPING_FORM_ERROR_SELECTED]: 'addressInvalid',
  [ADDRESS.INVALID_PHONE]: 'mobileNumberInvalid',
  [CVS_NOTIFICATIONS.EXCEEDS_STORE_LIMIT]: 'exceedCvsAmountLimitError',
  [BOPIS_NOTIFICATION.STORE_CHANGED]: 'storeChangeWarning',
  [RESTRICTION_ERRORS.RESTRICTION_APO_ADDRESS]: 'restrictedApoAddress',
  [RESTRICTION_ERRORS.RESTRICTION_OVERSEAS_TERRITORY]: 'shippingRestrictionOverseasTerritory',
  [RESTRICTION_ERRORS.RESTRICTION_APO_ADDRESS_MILITARY]: 'restrictedApoAddress',
  [RESTRICTION_ERRORS.RESTRICTION_APO_ADDRESS_POBOX]: 'restrictedApoAddress',
  [RESTRICTION_ERRORS.RESTRICTION_APO_ADDRESS_TERRITORY]: 'restrictedApoAddress',
  [ADDRESS.TAX_PROVIDER_ERROR]: 'restrictedState',
  [RESTRICTION_ERRORS.RESTRICTION_ZIPCODE]: 'shippingRestrictionHazmatZipcode',
  [RESTRICTION_ERRORS.SHIPPING_RESTRICTIONS_STATES]: 'restrictedState',
  [RESTRICTION_ERRORS.SHIPPING_UNAVAILABLE_FOR_ADDRESS]: 'shippingUnavailableForAddress',
  [ADDRESS.DIFFERENT_ADDRESS_FROM_LOCATION]: 'differentLocationError',
  [ADDRESS.GENERIC]: 'genericError',
  [CART_NOTIFICATIONS.OFFER_REMOVED]: 'offerCodeRemoved',
  [CART_NOTIFICATIONS.DONATION_REMOVED]: 'donationHasBeenRemoved',
  [REPLENISHMENT]: 'replenishmentRemovedError',
  [PRODUCT.REMOVED_ITEM_SOLD_OUT]: 'productRemovedError',
  [PRODUCT.REMOVED_ITEM_INACTIVE]: 'productRemovedError',
  [PRO.BILLSHIP_MISMATCH]: 'identicalShippingAddressBillingAddress',
  [CART.TRANSACTIONS_LIMIT]: 'transLimit',
  [PAYMENT_ERRORS.CANNOT_PROCESS]: 'paymentProviderError',
  [PAYMENT_ERRORS.DELIVERY_EXPIRED] : 'sameDayDeliveryTimeWarning',
  [PAYMENT_ERRORS.CARD_NOT_RECOGNIZED]: 'paymentDeclined', // TODO: This is tmp. Fix/Remove after <LATAMMAINT-9118> is completed.
  [PAYMENT_ERRORS.NO_CARD_INSTALLMENT]: 'noCardInstallmentError',
  [PAYMENT_ERRORS.NO_CARD_REDEMPTION]: 'noCardRedemptionError',
  [PAYMENT_ERRORS.PAYMENT_PROVIDER_PROTOCOL_ERROR]: 'paymentProviderError',
  [PAYMENT_ERRORS.PAYMENT_ATTEMPTS_EXCEEDED]: 'paymentAttemptsExceeded',
  [PAYMENT_ERRORS.PAYMENT_DECLINED]: 'paymentDeclined',
  [PAYMENT_ERRORS.THREE_DS]: 'paymentProvider3dsError',
  [PAYMENT_ERRORS.CART_CHANGED]: 'cartChangedError',
  [PAYMENT_ERRORS.PAYPAL_CANNOT_CONNECT]: 'paypalCannotConnectError',
  [PAYMENT_ERRORS.REQUIRED_PRIVACY_POLICY]: 'termsConditionsRequiredError',
  [ADDRESS_NOTIFICATIONS.AFTERPAY_UNAVAILABLE]: 'afterpayAddressWarning',
  [ADDRESS_NOTIFICATIONS.APO_NOTIFICATION]: 'deliveryMethodStandard',
  [ADDRESS_NOTIFICATIONS.OFFER_REPLACED_SKUS_RESTRICTED]: 'offerReplacedSkusRestricted',
  [SHIPPING_NOTIFICATIONS.PRODUCT_HAZMAT_RESTRICTION]: 'shippingRestrictionHazmat',
  [SHIPPING_PAYMENT_NOTIFICATIONS.NON_KOREAN_SHIPPING]: 'nonKoreanShippingAddressWarning',
  [SHIPPING_PAYMENT_NOTIFICATIONS.SHIPPING_SET_TO_DEFAULT]: 'shippingSetToStandard',
  [GIFT_MESSAGE.PROFANIFY_FILTER]: 'onlyEnglishLanguageCharactersAreAccepted',
});
